import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class IncrementNumber {
    public total=1;
    increment() {
        return this.total++;
    }
}